import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DefaultCriteria from "../components/criteria/DefaultCriteria";
import DetailCriteria from "../components/criteria/DetailCriteria";

import modelObj from "../utils/cookieUtils";
import { setItem } from "../utils/storageUtils";

import { intervalLogging, stopLogging } from "../components/common/logger";

export default function GameCriteria(props) {
    const [onOff, setOnOff] = useState(false);
    const location = useLocation();

    // const [wholePlayers, setWholePlayers] = useState();
    // const [oppWholePlayers, setOppWholePlayers] = useState();

    let movingHandler = props.movingHandler;

    useEffect(() => {
        props.setMenuTitle("경기 조회");
        if (props.criteria) {
            stopLogging();
            setItem("gameCriteria", props.criteria);
            intervalLogging(location.pathname);
        }

        modelObj.renderLanguage();

    }, [props.criteria]);

    const settingCriteriaHandler = (evt) => {
        if(props.criteria.minBallSpeed != "" && props.criteria.maxBallSpeed == ""){
            //만약 구속 최소값만 선택하고 최대값을 선택하지 않았을 경우
            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: [],
                maxBallSpeed: "200"
            }));
        } else if (props.criteria.minBallSpeed == "" && props.criteria.maxBallSpeed != ""){
            //만약 구속 최솟값은 선택하지 않고 최대값만 선택했을 경우
            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: [],
                minBallSpeed: "0"
            }));
        } else if(props.criteria.minBallSpeed == "" && props.criteria.maxBallSpeed == "") {
            //둘다 선택하지 않았을 경우
            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: [],
                minBallSpeed: "",
                maxBallSpeed: ""
            }));
        } else {
            //둘다 선택 했을 경우
            props.setCriteria((prevState) => ({
                ...prevState,
                gameInfoIds: [],
            }));
        }

        // if(props.criteria.pitcherIds.length == 0){
        //     //만약 투수가 선택이 안되어있다면
        //     if(props.criteria.position == "pitcher"){
        //         //선수유형 - 투수라면
        //         props.setCriteria((prevState) => ({
        //             ...prevState,
        //             pitcherIds:wholePlayers,
        //             playerIds:wholePlayers
        //         }));
        //     } else {
        //         //선수유형 - 타자라면
        //         props.setCriteria((prevState) => ({
        //             ...prevState,
        //             pitcherIds:oppWholePlayers,
        //             oppPlayerIds:oppWholePlayers

        //         }));
        //     }
        // }

        // if(props.criteria.batterIds.length == 0){
        //     //만약 타자가 선택이 안되어있다면
        //     if(props.criteria.position == "pitcher"){
        //         //선수유형 - 투수라면
        //         props.setCriteria((prevState) => ({
        //             ...prevState,
        //             batterIds:oppWholePlayers,
        //             oppPlayerIds:oppWholePlayers
        //         }));
        //     } else {
        //         //선수유형 - 타자라면
        //         props.setCriteria((prevState) => ({
        //             ...prevState,
        //             batterIds:wholePlayers,
        //             playerIds:wholePlayers
        //         }));
        //     }
        // }
        
        movingHandler("/clip/gameList");
    };

    const resetCriteriaHandler = () => {
        props.resetHandler();
    };

    const openDetailCriteriaHandler = () => {
        let isOpen = onOff ? false : true;
        setOnOff(isOpen);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <DefaultCriteria
                    criteria={props.criteria}
                    setCriteria={props.setCriteria}
                    useLang={props.useLang}
                    // setWholePlayers={setWholePlayers}
                    // setOppWholePlayers={setOppWholePlayers}
                />
                <div className="col-12">
                    <button
                        id="openCriteria"
                        className="btn text-center"
                        data-lang="detailSearch"
                        style={{
                            background: "#e3e3e3",
                            padding: "5px",
                            marginTop: "20px",
                            marginBottom: "15px",
                            fontSize: "13px",
                            cursor: "pointer",
                            width: "100%",
                            border: "1px solid #e3e3e3",
                        }}
                        onClick={openDetailCriteriaHandler}
                    >
                        상세 조회 &#x025BD;
                    </button>
                </div>
                <DetailCriteria
                    onOff={onOff}
                    criteria={props.criteria}
                    setCriteria={props.setCriteria}
                    detailCriteria={props.detailCriteria}
                    useLang={props.useLang}
                    isMobile={props.isMobile}
                />
            </div>
            <div className="row" style={{ marginTop: "50px" }}>
                <div
                    className="col-6"
                    style={{
                        paddingRight: "3px",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <button
                        id="resetCriteria"
                        onClick={resetCriteriaHandler}
                        className="btn btn-secondary shadow"
                        style={{
                            width: "130px",
                            backgroundColor: "#000",
                            color: "#fff",
                        }}
                    >
                        Reset
                    </button>
                </div>
                <div className="col-6" style={{ paddingLeft: "3px" }}>
                    <button
                        id="retrieveGame"
                        onClick={settingCriteriaHandler}
                        className="btn btn-secondary shadow"
                        data-lang="search"
                        style={{
                            width: "130px",
                            backgroundColor: "#fff",
                            color: "#000",
                        }}
                    >
                        경기 조회
                    </button>
                </div>
            </div>
        </div>
    );
}
